import * as s from "../node_modules/.pnpm/three@0.172.0/node_modules/three/build/three.tsl.js";
const {
  vec2: n,
  fract: r,
  sin: c,
  dot: e
} = s, m = (t) => r(c(e(t, n(12.12345, 78.12345))).mul(40000.12345)), i = (t = 0.03) => (o) => m(o).mul(t).mul(0.10012345);
export {
  i as grain,
  m as noise
};
